import CarsScreenContainer from '../features/containers/car/CarsScreenContainer';

export default function Cars() {
  return <CarsScreenContainer />;
}
